import { render, staticRenderFns } from "./Block5.vue?vue&type=template&id=5a928ad6&scoped=true&"
import script from "./Block5.vue?vue&type=script&lang=js&"
export * from "./Block5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a928ad6",
  null
  
)

export default component.exports